import { useEffect, useState } from "react";
import { Shield } from "lucide-react";

// Landing point after a successful SAML ACS exchange. Tokens arrive in the
// URL fragment (never sent to the server), get stored, then a full reload
// lets AuthContext bootstrap from localStorage.
export default function SsoCallback() {
  const [message, setMessage] = useState("Completing single sign-on...");

  useEffect(() => {
    const raw = window.location.hash.startsWith("#")
      ? window.location.hash.slice(1)
      : window.location.hash;
    const params = new URLSearchParams(raw);
    const next = params.get("next") || "/app";

    // Tokens were persisted pre-mount by index.js (before AuthContext init).
    if (localStorage.getItem("access_token") && localStorage.getItem("refresh_token")) {
      const safeNext = next.startsWith("/") ? next : "/app";
      window.location.replace(safeNext);
    } else {
      setMessage("SSO sign-in failed — redirecting to login...");
      setTimeout(() => {
        window.location.replace(
          "/login?sso_error=" + encodeURIComponent("SSO sign-in did not return valid credentials")
        );
      }, 1500);
    }
  }, []);

  return (
    <div className="min-h-screen flex flex-col items-center justify-center bg-[#0a0e1a] gap-4">
      <Shield className="w-10 h-10 text-blue-500 animate-pulse" />
      <div className="text-slate-300 text-sm" data-testid="sso-callback-status">{message}</div>
    </div>
  );
}
